import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ErrorComponent } from './error.component';
import { ThemeResolver } from '../../theme/theme.resolver';

const routes: Routes = [
  {
    path: 'error',
    component: ErrorComponent,
    resolve: { theme: ThemeResolver }
  }
];

export const router: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./src/app/modules/error/error.routes.ts